module.exports = __webpack_public_path__ + "static/1-8a63baa7565f123006363b4f06665b6d.jpeg";